import React from 'react'
import MaskedInput from 'react-maskedinput'
type Props = {
    invalid: boolean
    onClick: (...args: Array<any>) => any
    onClickContainer: (...args: Array<any>) => any
}
export default class CustomDateTimeInput extends React.Component<Props> {
    input: MaskedInput

    constructor(props: Props) {
        super(props)
        this.input = React.createRef()
    }

    focus() {
        this.input.current.focus()
    }

    render() {
        const { invalid, onClick, onClickContainer, ...maskedInputProps } = this.props

        return (
            <div onClick={onClickContainer} className="input-group">
                <MaskedInput
                    ref={this.input}
                    mask="11/11/1111 11:11:00 aa"
                    className={`${invalid ? 'error' : 'success'} with-right-addon`}
                    type="text"
                    {...maskedInputProps}
                />
                <span onClick={onClick} className="input-group-addon input-group-addon--white input-group-addon-right">
                    <i className="fa fa-calendar" />
                </span>
            </div>
        )
    }
}
